module.exports = __webpack_public_path__ + "static/media/earth.22810192.svg";